import React from 'react'
import './Footer.css'
function Footer() {
  return (
    <>
    <div className='parent'>
    <div className="foot">
    <h3>
        ABOUT
    </h3>
    </div>
    <hr style={{width:"800px"}}/>
    <div>
    <p style={{padding:'10px'}}>
    Dr. B.C. Roy Engineering College, Durgapur, popularly known as BCREC, was set up on 21st August, 2000, under the over all management of Dr. B.C. Roy Engineering College Society. Born of a vision of a group of Durgapur based philanthropic entrepreneurs, the institute is dedicated to the memory of Dr. Bidhan Chandra Roy, the architect of modern West Bengal and BCREC management is deeply committed to gradually build the college as one of the best seats of Engineering and Management Education in Eastern India with domestic and global requirements in view.
    </p>
    </div>
    </div>
    <div className='rights'>
    <h4>Copyright © 2022 All Rights Reserved by <a href={'https://github.com/Sooryavanshi1'}>Tushar Deo</a> and <a href={'https://github.com/singhaman19'}>Aman Kumar Singh</a>.</h4>
    </div>
    </>
  )
}

export default Footer